import React, { useState, useEffect } from "react";
import { Icon, useToast } from "@chakra-ui/react";
import { FiTrash2 } from "react-icons/fi";
import { MdCancel } from "react-icons/md";
import { BsCheckCircle } from "react-icons/bs";
import { arrayToOption } from "../../../../Utils/formatUtils";
import ResponsiveRow from "../../../Common/Table/ResponsiveRow";
import TdType from "../../../Common/Table/TdType";

const ClientItem = ({
  client,
  setShowNewClient,
  initialAction = "row",
  addClient,
  deleteClientHandler,
  clientsList,
  newClientsList,
  setIsEdited,
}) => {
  const [action, setAction] = useState(initialAction);
  const [newClient, setNewClient] = useState(client);
  const [clientsOptions, setClientsOptions] = useState([]);
  const toast = useToast();
  //const clientOptions = arrayToOption(clientsList, "id", "businessName");

  useEffect(() => {
    setNewClient(client);
    if (action === "new" || action === "edit") setIsEdited(true);
  }, [action]);

  useEffect(() => {
    let parsedClients = [...clientsOptions];
    setClientsOptions(parsedClients);
  }, []);

  const validateForm = async () => {
    if (!newClient.id) {
      toast({
        title: "Se ha producido un error.",
        description: "Revise los datos ingresados.",
        status: "error",
        duration: 4000,
        isClosable: true,
      });
    } else {
      addClient(newClient);
      setShowNewClient(false);
      setAction("row");
    }
  };

  const handleSubmit = () => {
    validateForm();
  };

  const handleClientChange = (val) => {
    let clientInList = newClientsList.find((cli) => cli.id == val.value);
    if (typeof clientInList !== "undefined") {
      toast({
        title: "Error al cargar cliente.",
        description: "El cliente ya se encuentra en el listado.",
        status: "error",
        duration: 4000,
        isClosable: true,
      });
      return false;
    }

    let client = clientsList.find((cli) => cli.id == val.value);

    setNewClient({
      ...newClient,
      id: val.value,
      businessName: client.businessName,
      address: client.address,
      email: client.email,
      zoneName: client.zoneName,
      priceListName: client.priceListName,
    });
  };

  const rowDisplay = () => {
    let rowData = [];
    // eslint-disable-next-line default-case
    switch (action) {
      case "new":
        rowData = [
          {
            tdStyle: { w: "25%" },
            item: (
              <TdType
                inputType="modal"
                name={`businessName`}
                id={`businessName`}
                title={"Elija un cliente"}
                modalTitle={"Listado de clientes"}
                placeholder={"Elija un cliente"}
                options={arrayToOption(clientsList, "id", "businessName")}
                value={arrayToOption(clientsList, "id", "businessName").find(
                  (item) => item.value == newClient.id
                )}
                onChange={(val) => handleClientChange(val)}
              />
            ),
          },
          {
            item: <TdType text={newClient.address} />,
          },
          {
            item: <TdType text={newClient.email} />,
          },
          {
            item: <TdType text={newClient.zoneName} />,
          },
          {
            item: <TdType text={newClient.priceListName} />,
          },
          {
            tdStyle: {
              textAlign: "center",
              fontSize: "1.5em",
              w: "12%",
              px: "2",
            },
            item: (
              <>
                <Icon
                  _hover={{ cursor: "pointer" }}
                  mx="2"
                  as={BsCheckCircle}
                  color="green"
                  onClick={() => handleSubmit()}
                  title={"Aceptar"}
                ></Icon>
                <Icon
                  _hover={{ cursor: "pointer" }}
                  mx="2"
                  as={MdCancel}
                  color="red"
                  title={"Cancelar"}
                  onClick={() => setShowNewClient(false)}
                ></Icon>
              </>
            ),
          },
        ];
        return <ResponsiveRow key={client.id} cells={rowData}></ResponsiveRow>;
      case "row":
        rowData = [
          {
            item: <TdType text={newClient.businessName} />,
          },
          {
            item: <TdType text={newClient.address} />,
          },
          {
            item: <TdType text={newClient.email} />,
          },
          {
            item: <TdType text={newClient.zoneName} />,
          },
          {
            item: <TdType text={newClient.priceListName} />,
          },
          {
            tdStyle: {
              textAlign: "center",
              fontSize: "1.5em",
              w: "12%",
              px: "2",
            },
            item: (
              <>
                <Icon
                  as={FiTrash2}
                  _hover={{ cursor: "pointer" }}
                  mx="2"
                  title="Eliminar"
                  onClick={() => deleteClientHandler(client)}
                />
              </>
            ),
          },
        ];
        return <ResponsiveRow key={client.id} cells={rowData}></ResponsiveRow>;
    }
  };

  return <>{rowDisplay()}</>;
};

export default ClientItem;
